import { render } from "./TargetGroups.vue?vue&type=template&id=e4bebb22&scoped=true"
import script from "./TargetGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetGroups.vue?vue&type=script&setup=true&lang=js"

import "./TargetGroups.vue?vue&type=style&index=0&id=e4bebb22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bebb22"],['__file',"src/components/Paragraphs/TargetGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4bebb22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4bebb22', __exports__)) {
    api.reload('e4bebb22', __exports__)
  }
  
  module.hot.accept("./TargetGroups.vue?vue&type=template&id=e4bebb22&scoped=true", () => {
    api.rerender('e4bebb22', render)
  })

}


export default __exports__